const CACHE_PREFIX = 'hki-cache:';

function getStorageKey(key) {
  return `${CACHE_PREFIX}${key}`;
}

export function purgeStaleSessionCaches() {}

export function getSessionCache(key, maxAgeMs = 0) {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return null;
  }

  try {
    const rawValue = window.sessionStorage.getItem(getStorageKey(key));

    if (!rawValue) {
      return null;
    }

    const parsedValue = JSON.parse(rawValue);

    if (!parsedValue || typeof parsedValue !== 'object') {
      return null;
    }

    const age = Date.now() - Number(parsedValue.timestamp || 0);

    if (maxAgeMs > 0 && age > maxAgeMs) {
      window.sessionStorage.removeItem(getStorageKey(key));
      return null;
    }

    return parsedValue.data ?? null;
  } catch (_) {
    return null;
  }
}

export function setSessionCache(key, data) {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return;
  }

  try {
    window.sessionStorage.setItem(
      getStorageKey(key),
      JSON.stringify({
        timestamp: Date.now(),
        data,
      })
    );
  } catch (_) {}
}

export function removeSessionCache(key) {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return;
  }

  try {
    window.sessionStorage.removeItem(getStorageKey(key));
  } catch (_) {}
}
